export default "__VITE_ASSET__BHWpwWF7__"